import { render } from "./footer.vue?vue&type=template&id=95335216"
const script = {}

import exportComponent from "/vercel/path0/cob-shareable-pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__